import React from 'react';
import styled from 'styled-components';

const LogoImageSC = styled.img`
  margin-top: 1.25rem;
  margin-bottom: 1rem;
  width: 13.625rem;

  @media (max-width: ${(props) => `${parseInt(props.theme.SizeBreakpointsS, 10) - 1}px`}) {
    margin-top: 1rem;
    width: 10.25rem;
  }
`;

export default function AppLogo() {
  return (
    <LogoImageSC
      src="https://media.nedigital.sg/nedigital/files/b6d8a39d-5831-42b1-adf5-2ffa86da8fc3/logo.svg"
      alt="FairPrice"
    />
  );
}
